import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export const CHANNEL_FORM_DRAFT_TTL_MS = 60 * 60 * 1000;

type ChannelFormDraftValue = Record<string, unknown>;

interface ChannelFormDraftEntry {
  values: ChannelFormDraftValue;
  updatedAt: number;
}

interface ChannelFormDraftsState {
  byKey: Record<string, ChannelFormDraftEntry>;
}

interface UpsertChannelFormDraftPayload {
  key: string;
  values: ChannelFormDraftValue;
  updatedAt?: number;
}

interface CleanupChannelFormDraftsPayload {
  now?: number;
}

const initialState: ChannelFormDraftsState = {
  byKey: {},
};

const channelFormDraftsSlice = createSlice({
  name: 'channelFormDrafts',
  initialState,
  reducers: {
    upsertDraft: (state, action: PayloadAction<UpsertChannelFormDraftPayload>) => {
      const { key, values, updatedAt } = action.payload;
      state.byKey[key] = {
        values,
        updatedAt: updatedAt ?? Date.now(),
      };
    },
    removeDraft: (state, action: PayloadAction<string>) => {
      delete state.byKey[action.payload];
    },
    cleanupExpired: (state, action: PayloadAction<CleanupChannelFormDraftsPayload | undefined>) => {
      const now = action.payload?.now ?? Date.now();
      const expireBefore = now - CHANNEL_FORM_DRAFT_TTL_MS;

      Object.entries(state.byKey).forEach(([key, entry]) => {
        if (entry.updatedAt < expireBefore) {
          delete state.byKey[key];
        }
      });
    },
    clearAllDrafts: (state) => {
      state.byKey = {};
    },
  },
});

export const { reducer: channelFormDraftsReducer, actions: channelFormDraftsActions } =
  channelFormDraftsSlice;
